import React from "react";
import Header from "../../components/header/index";
// import InnerHeader from '../../components/comment/innerHeader/innerHeader'

import Footer from "../../components/footer";
// import InnerHeaderBooking from "./innerheadercar/headerBokingList";
import InnerHeaderCheckout from "../../components/comment/innerHeader/innerHeaderCheckout";
import CarCheckoutContent from "./carcheckoutcontent/carCheckoutContent";

const carBookingCheckout = () => {
  return (
    <div className="main">
      <Header />
      <InnerHeaderCheckout />
      <CarCheckoutContent />
      <Footer />
    </div>
  );
};

export default carBookingCheckout;
